module.exports = __webpack_public_path__ + "static/img/vip.483652fa.png";